import { apiInstance, handleApiError } from "./InstanceApi";

export const getAttachFileService = async ({limit = 5, page = 1}) => {
    try {
        const response = await apiInstance.get('attach-file/list', {
            params: { limit, page, name }
        });
        return response.data;
    } catch (error) {
        return handleApiError(error);
    }
}


export const searchAttachFileService = async ({limit = 5, page = 1, name = ''}) => {
    try {
        const response = await apiInstance.get('attach-file/search', {
            params: { limit, page, name }
        });
        return response.data;
    } catch (error) {
        return handleApiError(error);
    }
}

export const UploadAttach = async ({data}) => {
    try {
        const formData = new FormData();
        formData.append('file_att', data.file);
        formData.append('name', data.name);
        formData.append('detail', data.detail);

        const response = await apiInstance.post('attach-file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    } catch (error) {
        return handleApiError(error);
    }
}

export const UpdateAttach = async ({id, data}) => {
    try {
        const formData = new FormData();
        formData.append('file_att', data.file);
        formData.append('name', data.name);
        formData.append('detail', data.detail);

        const response = await apiInstance.post(`attach-file/update/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    } catch (error) {
        return handleApiError(error);
    }
}

export const deleteAttachFileService = async ({id}) => {
    try {
        const response = await apiInstance.delete(`attach-file/${id}`)
        return response.data;
    } catch (error) {
        return handleApiError(error)
    }
}
